/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Paramedic from './paramedic';
import ParamedicDetail from './paramedic-detail';
import ParamedicUpdate from './paramedic-update';
import ParamedicDeleteDialog from './paramedic-delete-dialog';

const ParamedicRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Paramedic />} />
    <Route path="new" element={<ParamedicUpdate />} />
    <Route path=":id">
      <Route index element={<ParamedicDetail />} />
      <Route path="edit" element={<ParamedicUpdate />} />
      <Route path="delete" element={<ParamedicDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ParamedicRoutes;
